import React, { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { MultiSelectOption } from "../../models/MultiSelectOption";
import Label from "../label/label";
import SettingSelectField from "../settingFields/SettingSelectField";
import Togglebox from "../togglebox/togglebox";
import { useFormikContext } from "formik";

const EventTypeForm: FC = () => {
    const { translate } = useLocale();
    const priorityLevelOptions: MultiSelectOption[] = [
        { label: translate.byKey(TranslationKeys.standard), value: '0' },
        { label: translate.byKey(TranslationKeys.high), value: '1' },
    ];
    const { values } = useFormikContext<any>();

    return <div className="flex flex-col mb-2 space-y-3">
        <div className="flex flex-col">
            <Label
                htmlFor="etAlarm"
                className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.alarm)}:</Label>
            <div className="flex flex-row justify-between w-full" id='etAlarmField'>
                <Togglebox name="etAlarm" label="" />
            </div>
        </div>
        <div className="flex flex-col">
            <Label
                htmlFor="etPriorityLevel"
                className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.priorityLevel)}:</Label>
            <div className="flex flex-row justify-between w-full" id='etPriorityLevelField'>
                <SettingSelectField
                    disabled={values.etAlarm == "0"}
                    className="flex w-full"
                    accessor={`etPriorityLevel`}
                    options={priorityLevelOptions} />
            </div>
        </div>
    </div>
}

export default EventTypeForm;